export enum Location {
	DAKAR = 'Dakar',
	THIES = 'Thiès',
	SAINTLOUIS = 'Saint-Louis',
}

export enum State {
	NEW = 'Neuf',
	USED = 'Seconde main',
}
